import React from "react";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "destructive" | "destructive-outline";
  size?: "sm" | "md" | "lg";
  className?: string;
  children: React.ReactNode;
}

export function Button({
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...props
}: ButtonProps) {
  const sizeClasses: Record<string, string> = {
    sm: "px-3 py-1.5 text-xs",
    md: "px-4 py-2",
    lg: "px-6 py-3",
  };

  const baseClasses = `rounded-[6px] transition-colors font-normal flex items-center justify-center ${sizeClasses[size]}`;

  const variantClasses: Record<string, string> = {
    primary: "bg-duvi-accent text-white hover:bg-duvi-accent-hover",
    secondary:
      "bg-duvi-surface border border-duvi-border text-duvi-text-primary hover:bg-duvi-elevated",
    destructive: "bg-duvi-destructive text-white hover:bg-[#DC2626]",
    "destructive-outline":
      "bg-transparent border border-duvi-destructive text-duvi-destructive hover:bg-duvi-destructive/10",
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant] ?? variantClasses.primary} ${className}`}
      style={{ fontSize: size === "sm" ? "var(--text-xs)" : "var(--text-sm)" }}
      {...props}
    >
      {children}
    </button>
  );
}
